import React, {useEffect, useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from '@mui/material/Skeleton';
import { useDispatch } from "react-redux";
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
  } from "@chakra-ui/react";
import { Box } from "@mui/material"; 
import {fetchPiGarantiesData} from "../../../store/action/garantiesFromPi";


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        position: 'relative',
    },
    paper: {
        display: 'grid',
        gridTemplateRows: '0.5fr 1fr 1.5fr',
        gap: '20px',
        padding: '20px',
        borderRadius: '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
    },
    previewBtn: {
        position: 'absolute',
        //background: 'rgb(243, 246, 249)',
        right: '20px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    },
    firstPart: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '35px',
    },
    secondPart: {
        display: 'block',
    },
    thirdPart: {
        display: 'grid',
        gridTemplateColumns: '60% 40%',
        // gap: '5px',
        alignItems: 'center',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
    },
    tableHeader: {
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: 700,
        textAlign: 'left',
        color: 'rgba(70, 78, 95, 1)',
        paddingBottom: '10px',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
    },
    tableTh: {
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 600,
        color: 'rgba(181, 181, 195, 1)',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        textAlign: 'left',
        paddingLeft: '5px',
        paddingBottom: '12px',
        paddingTop: '12px',
    },
    tableRow: {
        padding: '0',
    },
    tableContent: {
        paddingLeft: '5px',
        textAlign: 'left',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        paddingBottom: '9px',
        paddingTop: '12px',
    },
    selectInput: {
        width: '70%',
        //padding: '10px',
        fontSize: '14px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        //marginTop: '5px',
        //marginBottom: '15px',
    },
    card: {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: 0,
        },
        minHeight: '200px',
    },
    cardItem: {
        display: 'flex',
        justifyContent: 'space-between',
        color: 'rgba(128, 128, 143, 1)',
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '13px',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        paddingBottom: '3px',
        paddingTop: '3px',
        alignItems: 'center'
    },
    optionText: {
        padding: "5px",
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: "70%",
        height: '36px',
        borderRadius: 4,
        marginBottom: "20px",
    },
    inputLabel: {
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputText: {
        border: '1px solid rgba(231, 231, 231, 1)',
        background: 'rgba(255, 255, 255, 1)',
        width: '176px',
        height: '36px',
        textAlign: 'right',
        borderRadius: '4px 0px 0px 0px',
        opacity: '1',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
}));
const ContractData = (props) => {

    const classes = useStyles(); 
    const dispatch = useDispatch();
    const [garanties, setGaranties] = useState([]);  
    const [loading, setLoading] = useState(false);
    function formatDateFR(dateString) {
        const date = new Date(dateString);
      
        if (isNaN(date)) {
          throw new Error("Date invalide");
        }
      
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
      
        return `${day}/${month}/${year}`;
      }
    const fetchGaranties = async () => {
        setLoading(true);  
        const garantiesData = dispatch(fetchPiGarantiesData(props.policyNumber , formatDateFR(props.occurrenceDate) ));
        const filteredGuarantees = garantiesData?.listGaranties?.filter(garantie => garantie.codeGarantie === props.affectedWaranties.replace(/'/g, ''));
        setGaranties(filteredGuarantees);
        setLoading(false);
      };

    useEffect(() => {
        fetchGaranties();
    }, []);
 
        return (
             

              <table className={classes.table}>
                                <thead>
                                <tr className={classes.tableHeader}>
                                    <th colSpan="5">Données Contrat</th>
                                </tr>
                                <tr>
                                    <th className={classes.tableTh}>Garantie</th>
                                    <th className={classes.tableTh}>Plafond</th>
                                    <th className={classes.tableTh}>Franchise</th>
                                    <th className={classes.tableTh}>Usage</th>
                                    <th className={classes.tableTh}>Type Bénéficiaire</th> 
                                </tr>
                                </thead>
                                <tbody>
                                    {loading  ? (
                                       <> {[...Array(3)].map((_, index) => (
                                            <tr key={index} className={classes.tableRow}>
                                              <td className={classes.tableContent}>
                                                <Skeleton size="30px" animation="wave" width={160} height={30} />
                                              </td>
                                              <td className={classes.tableContent}>
                                                <Skeleton size="30px" animation="wave" width={160} height={30} />
                                              </td>
                                              <td className={classes.tableContent}>
                                                <Skeleton size="30px" animation="wave" width={160} height={30} />
                                              </td>
                                              <td className={classes.tableContent}>
                                                <Skeleton size="30px" animation="wave" width={160} height={30} />
                                              </td>
                                              <td className={classes.tableContent}>
                                                <Skeleton size="30px" animation="wave" width={160} height={30} />
                                              </td>
                                            </tr>
                                          ))}
                                        </> 
                                    ): (
                                        garanties ? ( garanties?.listGaranties?.map((garantie) => (
                                            <tr className={classes.tableRow} key={garantie?.idGarantie }>
                                                <td className={classes.tableContent}>{garantie?.garantie}</td>
                                                <td className={classes.tableContent}>{garantie.capital ? garantie.capital : '-'}</td>
                                                <td className={classes.tableContent}>{garantie.franchise ? garantie.franchise : '-'}</td>
                                                <td className={classes.tableContent}>{garanties.usage}</td>
                                                <td className={classes.tableContent}>{garanties.typePersonne}</td> 
                                            </tr>
                                        )) )
                                        : (<tr className={classes.tableRow}>
                                            <td className={classes.tableContent}>-</td>
                                            <td className={classes.tableContent}>-</td>
                                            <td className={classes.tableContent}>-</td>
                                            <td className={classes.tableContent}>-</td>
                                            <td className={classes.tableContent}>-</td> 
                                        </tr>)
                                    )}
                                 
                                 
                                </tbody>
                            </table>
            
 
             
        );

}

export default ContractData;